// frontend/src/pages/Quotes/QuotesList.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseDate } from '../../utils/dates';
import ProtectedComponent from '../../components/ProtectedComponent';
import PDFViewerModal from '../../components/Modals/PDFViewerModal';
import { PERMISSIONS } from '../../utils/permissions';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Table,
  Badge,
  Input,
  InputGroup,
  InputGroupText,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledDropdown,  // ✅ AGREGAR
  DropdownToggle,        // ✅ AGREGAR
  DropdownMenu,          // ✅ AGREGAR
  DropdownItem,          // ✅ AGREGAR
} from 'reactstrap';
import { quotesAPI, usersAPI } from '../../services/api';  // ✅ Agregar usersAPI
 // ✅ Agregar usersAPI

function QuotesList() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterTime, setFilterTime] = useState('all');
  const [customDateRange, setCustomDateRange] = useState({ start: '', end: '' });
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sellers, setSellers] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfTitle, setPdfTitle] = useState('');

  useEffect(() => {
    loadQuotes();
  }, [filterStatus, filterTime, customDateRange, selectedSeller]);

  useEffect(() => {
    loadSellers();
  }, []);

  const buildQuoteParams = () => {
    const params = {
      page_size: 1000,
    };
    
    if (filterStatus !== 'all') {
      params.status = filterStatus;
    }
    if (selectedSeller) {
      params.seller = selectedSeller;
    }
    
    const now = new Date();
    if (filterTime === 'week') {
      const startOfWeek = new Date(now);
      const dayOfWeek = startOfWeek.getDay();
      const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      startOfWeek.setDate(startOfWeek.getDate() + diffToMonday);
      params.created_after = startOfWeek.toISOString().split('T')[0];
    } else if (filterTime === 'month') {
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      params.created_after = startOfMonth.toISOString().split('T')[0];
    } else if (filterTime === 'custom' && customDateRange.start && customDateRange.end) {
      params.created_after = customDateRange.start;
      params.created_before = customDateRange.end;
    }
    
    return params;
  };

  const fetchAllQuotes = async (baseParams) => {
    let page = 1;
    let allQuotes = [];
    let hasMore = true;

    while (hasMore) {
      const response = await quotesAPI.getAll({
        ...baseParams,
        page,
      });

      const payload = response.data;

      if (Array.isArray(payload)) {
        return payload;
      }

      const pageResults = Array.isArray(payload.results) ? payload.results : [];
      allQuotes = [...allQuotes, ...pageResults];

      hasMore = Boolean(payload.next) && pageResults.length > 0;
      page += 1;
    }

    return allQuotes;
  };

  const loadQuotes = async () => {
    try {
      setLoading(true);
      const allQuotes = await fetchAllQuotes(buildQuoteParams());
      setQuotes(Array.isArray(allQuotes) ? allQuotes : []);
    } catch (error) {
      console.error('Error al cargar propuestas:', error);
      setQuotes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async (quoteId) => {
    if (!window.confirm('¿Estás seguro de rechazar esta propuesta? Esta acción no se puede deshacer.')) {
      return;
    }

    try {
      await quotesAPI.rejectQuote(quoteId);
      alert('Propuesta rechazada exitosamente');
      loadQuotes();
    } catch (error) {
      console.error('Error al rechazar propuesta:', error);
      alert(error.response?.data?.error || 'Error al rechazar propuesta');
    }
  };

  const loadSellers = async () => {
    try {
      const response = await usersAPI.getAll({ 
        page_size: 100,
        is_seller: true,
        is_approved: true,
        is_active: true,
      });
      
      const data = response.data.users || response.data.results || response.data || [];
      setSellers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error cargando vendedores:', error);
      setSellers([]);
    }
  };

  const applyCustomFilter = () => {
    if (!customDateRange.start || !customDateRange.end) {
      alert('Por favor selecciona ambas fechas');
      return;
    }
    setFilterTime('custom');
    setShowCustomModal(false);
  };

  const clearCustomFilter = () => {
    setCustomDateRange({ start: '', end: '' });
    setFilterTime('all');
    setShowCustomModal(false);
  };

  const viewInvoice = (invoice) => {
    if (!invoice?.pdf_url) {
      alert(`El PDF de la factura ${invoice?.folio || ''} no está disponible`);
      return;
    }

    setPdfUrl(invoice.pdf_url);
    setPdfTitle(`Factura ${invoice.folio}`);
    setPdfViewerOpen(true);
  };

  const filteredQuotes = quotes.filter((quote) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (quote.proposal_number && quote.proposal_number.toLowerCase().includes(searchLower)) ||
      (quote.client_name && quote.client_name.toLowerCase().includes(searchLower)) ||
      (quote.client_id_display && quote.client_id_display.includes(searchTerm)) ||
      (Array.isArray(quote.invoices) && quote.invoices.some((invoice) =>
        invoice.folio?.toLowerCase().includes(searchLower)
      ))
    );
  });

  const getStatusBadge = (status) => {
    const badges = {
      pending: { color: 'warning', text: 'En Proceso' },
      accepted: { color: 'primary', text: 'Aceptada' },
      rejected: { color: 'danger', text: 'Rechazada' },
      archived: { color: 'secondary', text: 'Archivada' },
    };
    return badges[status] || badges.pending;
  };

  /**
   * ✅ NUEVA FUNCIÓN: Obtener badge de días con colores según rangos
   * - Verde: 0-15 días (saludable)
   * - Amarillo: 16-30 días (atención)
   * - Rojo: 31+ días (urgente)
   */
  const getDaysBadge = (quote) => {
    const days = quote.days_elapsed;
    
    // Si no hay días (rechazada o archivada), mostrar N/A
    if (days === null || days === undefined) {
      return {
        color: 'primary',
        text: 'N/A',
        icon: null,
      };
    }
    
    // Determinar color según rango
    let color, icon;
    if (days <= 15) {
      color = 'primary';
      icon = 'ni-check-bold';
    } else if (days <= 30) {
      color = 'warning';
      icon = 'ni-watch-time';
    } else {
      color = 'danger';
      icon = 'ni-bell-55';
    }
    
    // Texto según estado
    const isAccepted = quote.status === 'accepted';
    const text = isAccepted ? `${days} días` : `${days} días`;
    
    return { color, text, icon, isAccepted };
  };

  const totalQuotes = quotes.length;
  const pendingQuotes = quotes.filter((q) => q.status === 'pending').length;
  const acceptedQuotes = quotes.filter((q) => q.status === 'accepted').length;
  const rejectedQuotes = quotes.filter((q) => q.status === 'rejected').length;
  const amountQuotes = filterStatus === 'all'
    ? quotes.filter((q) => q.status === 'accepted')
    : quotes;
  const totalAmount = amountQuotes.reduce((sum, q) => sum + parseFloat(q.subtotal || 0), 0);
  const amountTitle = filterStatus === 'all' ? 'Monto Aceptadas' : 'Monto Total';

  if (loading) {
    return (
      <>
        <div className="min-height-300 bg-gradient-primary position-absolute w-100"></div>
        <Container fluid className="py-4">
          <div className="text-center mt-5">
            <div className="spinner-border text-white" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3 text-white">Cargando propuestas...</p>
          </div>
        </Container>
      </>
    );
  }

  return (
    <>
      {/* ✅ Header con gradiente corporativo */}
      <div className="min-height-300 bg-gradient-primary position-absolute w-100"></div>

      <Container fluid className="py-4">
        {/* ✅ Stats Cards con iconos y sombras */}
        <Row>
          <Col xl="3" sm="6" className="mb-xl-0 mb-4">
            <Card className="shadow border-0">
              <CardBody className="p-3">
                <Row>
                  <div className="col-8">
                    <div className="numbers">
                      <p className="text-sm mb-0 text-uppercase font-weight-bold text-muted">
                        Total Propuestas
                      </p>
                      <h5 className="font-weight-bolder mb-0 text-dark">{totalQuotes}</h5>
                      <p className="mb-0">
                        <span className="text-success text-sm font-weight-bolder">
                          <i className="ni ni-bold-up me-1"></i>+12%
                        </span>
                        <span className="text-xs text-muted"> vs mes anterior</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-4 text-end">
                    <div className="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                      <i className="ni ni-single-copy-04 text-lg opacity-10 text-white" aria-hidden="true"></i>
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3" sm="6" className="mb-xl-0 mb-4">
            <Card className="shadow border-0">
              <CardBody className="p-3">
                <Row>
                  <div className="col-8">
                    <div className="numbers">
                      <p className="text-sm mb-0 text-uppercase font-weight-bold text-muted">En Proceso</p>
                      <h5 className="font-weight-bolder mb-0 text-dark">{pendingQuotes}</h5>
                      <p className="mb-0">
                        <span className="text-warning text-sm font-weight-bolder">
                          {totalQuotes > 0 ? Math.round((pendingQuotes / totalQuotes) * 100) : 0}%
                        </span>
                        <span className="text-xs text-muted"> del total</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-4 text-end">
                    <div className="icon icon-shape bg-gradient-warning shadow-warning text-center rounded-circle">
                      <i className="ni ni-watch-time text-lg opacity-10 text-white" aria-hidden="true"></i>
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3" sm="6" className="mb-xl-0 mb-4">
            <Card className="shadow border-0">
              <CardBody className="p-3">
                <Row>
                  <div className="col-8">
                    <div className="numbers">
                      <p className="text-sm mb-0 text-uppercase font-weight-bold text-muted">Aceptadas</p>
                      <h5 className="font-weight-bolder mb-0 text-dark">{acceptedQuotes}</h5>
                      <p className="mb-0">
                        <span className="text-success text-sm font-weight-bolder">
                          {totalQuotes > 0 ? Math.round((acceptedQuotes / totalQuotes) * 100) : 0}%
                        </span>
                        <span className="text-xs text-muted"> tasa de conversión</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-4 text-end">
                    <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                      <i className="ni ni-check-bold text-lg opacity-10 text-white" aria-hidden="true"></i>
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3" sm="6">
            <Card className="shadow border-0">
              <CardBody className="p-3">
                <Row>
                  <div className="col-8">
                    <div className="numbers">
                      <p className="text-sm mb-0 text-uppercase font-weight-bold text-muted">{amountTitle}</p>
                      <h5 className="font-weight-bolder mb-0 text-dark">
                        ${totalAmount.toLocaleString('es-MX', { maximumFractionDigits: 0 })}
                      </h5>
                      <p className="mb-0">
                        <span className="text-success text-sm font-weight-bolder">
                          <i className="ni ni-bold-up me-1"></i>+8%
                        </span>
                        <span className="text-xs text-muted"> vs mes anterior</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-4 text-end">
                    <div className="icon icon-shape bg-gradient-danger shadow-danger text-center rounded-circle">
                      <i className="ni ni-money-coins text-lg opacity-10 text-white" aria-hidden="true"></i>
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* ✅ Tabla de cotizaciones con diseño mejorado */}
        <Row className="mt-4">
          <Col lg="12">
            <Card className="shadow border-0 mb-4">
              {/* ✅ Header con gradiente */}
              <CardHeader className="bg-gradient-primary pb-3">
                <Row className="align-items-center">
                  <Col md="6">
                    <h6 className="mb-0 text-white">
                      <i className="ni ni-bullet-list-67 me-2"></i>
                      Lista de Propuestas
                    </h6>
                  </Col>
                  <Col md="6" className="text-end">
                    <ProtectedComponent permission={PERMISSIONS.CREATE_QUOTES}>
                      <Button 
                        color="white"
                        size="sm"
                        className="btn-icon shadow-sm"
                        onClick={() => navigate('/admin/inbox/quotes')}
                      >
                        <span className="btn-inner--icon">
                          <i className="ni ni-fat-add"></i>
                        </span>
                        <span className="btn-inner--text ms-2">Nueva propuesta</span>
                      </Button>
                    </ProtectedComponent>
                  </Col>
                </Row>
                
                {/* ✅ Filtros con estilo mejorado */}
                <Row className="mt-3">
                  <Col md="6">
                    <InputGroup className="input-group-alternative shadow-sm">
                      <InputGroupText className="bg-white">
                        <i className="fas fa-search text-muted"></i>
                      </InputGroupText>
                      <Input
                        type="text"
                        className="form-control-alternative"
                        placeholder="Buscar por número de propuesta o cliente..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="6" className="text-end">
                    <UncontrolledDropdown group size="sm" className="me-2">
                      <DropdownToggle caret color="white" className="shadow-sm">
                        <i className="ni ni-single-02 me-1"></i>
                        {selectedSeller 
                          ? sellers.find(s => s.id === selectedSeller)?.full_name || 'Vendedor'
                          : 'Todos los Vendedores'
                        }
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => setSelectedSeller(null)}>
                          <i className="ni ni-world me-2"></i>
                          Todos los Vendedores
                        </DropdownItem>
                        <DropdownItem divider />
                        {sellers.map(seller => (
                          <DropdownItem 
                            key={seller.id}
                            onClick={() => setSelectedSeller(seller.id)}
                            active={selectedSeller === seller.id}
                          >
                            <i className="ni ni-single-02 me-2"></i>
                            {seller.full_name || `${seller.first_name} ${seller.last_name}`}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <ButtonGroup size="sm">
                      <Button
                        color={filterStatus === 'all' ? 'white' : 'white'}
                        outline={filterStatus !== 'all'}
                        onClick={() => setFilterStatus('all')}
                        className="shadow-sm"
                      >
                        Todas
                      </Button>
                      <Button
                        color={filterStatus === 'pending' ? 'white' : 'white'}
                        outline={filterStatus !== 'pending'}
                        onClick={() => setFilterStatus('pending')}
                        className="shadow-sm"
                      >
                        <i className="ni ni-watch-time me-1"></i>
                        En Proceso
                      </Button>
                      <Button
                        color={filterStatus === 'accepted' ? 'white' : 'white'}
                        outline={filterStatus !== 'accepted'}
                        onClick={() => setFilterStatus('accepted')}
                        className="shadow-sm"
                      >
                        <i className="ni ni-check-bold me-1"></i>
                        Aceptadas
                      </Button>
                      <Button
                        color={filterStatus === 'rejected' ? 'white' : 'white'}
                        outline={filterStatus !== 'rejected'}
                        onClick={() => setFilterStatus('rejected')}
                        className="shadow-sm"
                      >
                        <i className="ni ni-fat-remove me-1"></i>
                        Rechazadas
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>

                {/* ✅ Filtros de tiempo */}
                <Row className="mt-3">
                  <Col md="12">
                    <div className="d-flex align-items-center">
                      <span className="text-sm me-2 text-white opacity-8">
                        <i className="ni ni-calendar-grid-58 me-1"></i>
                        Período:
                      </span>
                      <ButtonGroup size="sm">
                        <Button
                          color={filterTime === 'all' ? 'white' : 'white'}
                          outline={filterTime !== 'all'}
                          onClick={() => {
                            setFilterTime('all');
                            setCustomDateRange({ start: '', end: '' });
                          }}
                          className="shadow-sm"
                        >
                          <i className="ni ni-world me-1"></i>
                          Por Vida
                        </Button>
                        <Button
                          color={filterTime === 'month' ? 'white' : 'white'}
                          outline={filterTime !== 'month'}
                          onClick={() => {
                            setFilterTime('month');
                            setCustomDateRange({ start: '', end: '' });
                          }}
                          className="shadow-sm"
                        >
                          <i className="ni ni-calendar-grid-58 me-1"></i>
                          Este Mes
                        </Button>
                        <Button
                          color={filterTime === 'week' ? 'white' : 'white'}
                          outline={filterTime !== 'week'}
                          onClick={() => {
                            setFilterTime('week');
                            setCustomDateRange({ start: '', end: '' });
                          }}
                          className="shadow-sm"
                        >
                          <i className="ni ni-time-alarm me-1"></i>
                          Esta Semana
                        </Button>
                        <Button
                          color={filterTime === 'custom' ? 'white' : 'white'}
                          outline={filterTime !== 'custom'}
                          onClick={() => setShowCustomModal(true)}
                          className="shadow-sm"
                        >
                          <i className="ni ni-settings me-1"></i>
                          Custom
                        </Button>
                      </ButtonGroup>
                      
                      {filterTime === 'custom' && customDateRange.start && customDateRange.end && (
                        <Badge color="white" className="ms-2 shadow-sm">
                          <span className="text-dark">
                            {parseDate(customDateRange.start).toLocaleDateString('es-MX')} - {parseDate(customDateRange.end).toLocaleDateString('es-MX')}
                          </span>
                          <i 
                            className="fas fa-times ms-2 cursor-pointer text-danger" 
                            onClick={clearCustomFilter}
                            style={{ cursor: 'pointer' }}
                          ></i>
                        </Badge>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="px-0 pt-0 pb-2">
                <div className="table-responsive p-0">
                  <Table className="align-items-center mb-0" hover>
                    <thead>
                      <tr>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          # Propuesta
                        </th>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                          Cliente
                        </th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Monto
                        </th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Versión
                        </th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Estado
                        </th>
                        {/* ✅ NUEVA COLUMNA: Días */}
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Días
                        </th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                          Fecha
                        </th>
                        <th className="text-secondary opacity-7"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredQuotes.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center py-5">
                            <i className="ni ni-folder-17 text-muted" style={{ fontSize: '3rem' }}></i>
                            <p className="text-xs text-secondary mb-0 mt-3">
                              {searchTerm
                                ? 'No se encontraron propuestas con ese criterio'
                                : 'No hay propuestas registradas'}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        filteredQuotes.map((quote) => {
                          const quoteInvoices = Array.isArray(quote.invoices)
                            ? quote.invoices.filter((invoice) => invoice.status !== 'cancelled')
                            : [];
                          const isInvoiced = quoteInvoices.length > 0;
                          const statusBadge = isInvoiced
                            ? { color: 'success', text: 'Facturada' }
                            : getStatusBadge(quote.status);
                          const daysBadge = getDaysBadge(quote);
                          
                          return (
                            <tr 
                              key={quote.id}
                              style={{ cursor: 'pointer' }}
                              onClick={() => navigate(`/admin/quotes/${quote.id}`)}
                            >
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div>
                                    <div className="icon icon-shape icon-sm bg-gradient-primary shadow text-center rounded-circle me-2">
                                      <i className="ni ni-single-copy-04 text-white text-xs"></i>
                                    </div>
                                  </div>
                                  <div className="d-flex flex-column justify-content-center">
                                    <h6 className="mb-0 text-sm text-dark">{quote.proposal_number}</h6>
                                    <p className="text-xs text-secondary mb-0">
                                      <i className="ni ni-tag me-1"></i>
                                      {quote.category || 'Sin categoría'}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="text-sm font-weight-bold mb-0 text-dark">{quote.client_name}</p>
                                <p className="text-xs text-secondary mb-0">
                                  <i className="ni ni-calendar-grid-58 me-1"></i>
                                  {quote.quote_date ? parseDate(quote.quote_date).toLocaleDateString('es-MX') : 'Sin fecha'}
                                </p>
                              </td>
                              <td className="align-middle text-center">
                                <span className="text-dark text-sm font-weight-bold">
                                  ${parseFloat(quote.subtotal || 0).toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                                </span>
                              </td>
                              <td className="align-middle text-center">
                                <Badge color="" className="badge-sm bg-gradient-info shadow-sm">
                                  v{quote.version}
                                </Badge>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <Badge color="" className={`badge-sm bg-gradient-${statusBadge.color} shadow-sm`}>
                                  {statusBadge.text}
                                </Badge>
                                {isInvoiced && (
                                  <div className="d-flex flex-column align-items-center mt-1">
                                    {quoteInvoices.map((invoice) => (
                                      <button
                                        type="button"
                                        key={invoice.id}
                                        className="btn btn-link text-primary text-xs font-weight-bold p-0"
                                        title={`Ver factura ${invoice.folio}`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          viewInvoice(invoice);
                                        }}
                                      >
                                        <i className="ni ni-single-copy-04 me-1"></i>
                                        Factura {invoice.folio}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </td>
                              {/* ✅ NUEVA CELDA: Días con badge de colores */}
                              <td className="align-middle text-center">
                                <Badge 
                                  color="" 
                                  className={`badge-sm bg-gradient-${daysBadge.color} shadow-sm`}
                                  title={
                                    daysBadge.isAccepted 
                                      ? `Tiempo hasta aceptación: ${daysBadge.text}` 
                                      : quote.status === 'pending'
                                        ? `En proceso: ${daysBadge.text}`
                                        : 'No aplica'
                                  }
                                >
                                  {daysBadge.icon && (
                                    <i className={`ni ${daysBadge.icon} me-1`} style={{ fontSize: '0.65rem' }}></i>
                                  )}
                                  {daysBadge.text}
                                </Badge>
                              </td>
                              <td className="align-middle text-center">
                                <span className="text-secondary text-xs font-weight-bold">
                                  {parseDate(quote.created_at).toLocaleDateString('es-MX')}
                                </span>
                              </td>
                              <td className="align-middle">
                                {quote.status === 'pending' && (
                                  <Button
                                    color="danger"
                                    size="sm"
                                    className="btn-icon shadow-sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleReject(quote.id);
                                    }}
                                  >
                                    <span className="btn-inner--text ms-1">Rechazar propuesta</span>
                                  </Button>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* ✅ Modal Custom Date Range con diseño mejorado */}
      {pdfViewerOpen && (
        <PDFViewerModal
          isOpen={pdfViewerOpen}
          toggle={() => setPdfViewerOpen(false)}
          pdfUrl={pdfUrl}
          title={pdfTitle}
        />
      )}

      <Modal isOpen={showCustomModal} toggle={() => setShowCustomModal(false)} centered>
        <ModalHeader 
          toggle={() => setShowCustomModal(false)}
          className="bg-gradient-primary pb-3"
        >
          <h6 className="mb-0 text-white">
            <i className="ni ni-calendar-grid-58 me-2"></i>
            Filtro de Fechas Personalizado
          </h6>
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md="6">
              <Label className="form-control-label text-dark">
                <i className="ni ni-bold-right me-1"></i>
                Fecha Inicio
              </Label>
              <Input
                type="date"
                className="form-control-alternative shadow-sm"
                value={customDateRange.start}
                onChange={(e) => setCustomDateRange(prev => ({ ...prev, start: e.target.value }))}
              />
            </Col>
            <Col md="6">
              <Label className="form-control-label text-dark">
                <i className="ni ni-bold-left me-1"></i>
                Fecha Fin
              </Label>
              <Input
                type="date"
                className="form-control-alternative shadow-sm"
                value={customDateRange.end}
                onChange={(e) => setCustomDateRange(prev => ({ ...prev, end: e.target.value }))}
              />
            </Col>
          </Row>
          <div className="alert alert-info mt-3 shadow-sm">
            <span className="alert-icon">
              <i className="ni ni-bell-55"></i>
            </span>
            <span className="alert-text text-xs">
              Se filtrará por fecha de creación de la propuesta
            </span>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            color="secondary" 
            size="sm" 
            className="btn-icon shadow-sm"
            onClick={clearCustomFilter}
          >
            <span className="btn-inner--icon">
              <i className="ni ni-fat-remove"></i>
            </span>
            <span className="btn-inner--text ms-2">Limpiar</span>
          </Button>
          <Button 
            color="primary" 
            size="sm" 
            className="btn-icon shadow-sm"
            onClick={applyCustomFilter}
          >
            <span className="btn-inner--icon">
              <i className="ni ni-check-bold"></i>
            </span>
            <span className="btn-inner--text ms-2">Aplicar Filtro</span>
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default QuotesList;

